<main>
    <h1 style="color: #2D3C51; font-weight: bold; font-size: 32px; font-family: 'Roboto' !important;">ERROR 404: PAGE NOT FOUND</h1>
    <button (click)="handleOK()" style="background-color: #E9EAEF; color: #213060; line-height: 34px; padding: 0 25px; border-radius: 10px; border: none; margin-top: 20px; cursor: pointer;" mat-raised-button>Ok
    </button>
</main>